import styled from 'styled-components';
import { InteractiveIcon, token } from '@bynder/design-system';

export const DividerContainer = styled.div`
    position: relative;
    padding-left: ${token.spacing5};
    padding-right: ${token.spacing5};
    margin-left: calc(${token.spacing5} * -1);
    margin-right: calc(${token.spacing5} * -1);
    z-index: 1;
`;

export const Divider = styled.div<{ show: boolean }>`
    position: absolute;
    height: 100%;
    width: 2px;
    left: calc(${token.spacing5} - 1px);
    background-color: ${(props) => (props.show ? token.brandPrimary500 : 'transparent')};
    transition: background-color 70ms ease-out;
`;

export const CollapseExpandButtonContainer = styled.div<{ show: boolean; collapsed: boolean }>`
    position: absolute;
    width: ${token.layoutSpacing2};
    height: ${token.layoutSpacing6};
    left: ${(props) =>
        props.collapsed
            ? `calc(${token.layoutSpacing2} * -1)`
            : `calc(${token.spacing5} - ${token.layoutSpacing2} / 2)`};
    display: flex;
    justify-content: center;
    align-items: end;
    opacity: ${(props) => (props.show ? 1 : 0)};
    transition: opacity 70ms ease-out;
`;

export const CollapseExpandButton = styled(InteractiveIcon)`
    padding: 0;
    margin: 0;
    border-radius: ${token.radiusCircle};
    box-shadow: ${token.elevationStatic}, ${token.elevation2};
    background-color: ${token.white};
    transition: 70ms ease-out;
    color: ${token.gray400};

    &:hover {
        box-shadow: ${token.elevationStatic}, ${token.elevation8};
        background-color: ${token.gray100};
    }

    &:active {
        box-shadow: ${token.elevationStatic}, ${token.elevation1};
        background-color: ${token.gray100};
    }
`;
